import { Gql } from '@fiverr-private/dynamic_matching';
import { LightboxSourceType } from '@fiverr-private/overlay';

export const transformGqlMediaTypeToLightboxSourceType = (type: string | null | undefined): LightboxSourceType => {
    if (!type) return 'image';

    if (type.includes('image')) return 'image';
    if (type.includes('video')) return 'video';
    if (type.includes('pdf')) return 'pdf';
    if (type.includes('audio')) return 'audio';

    return 'image';
};

export const extractOriginalMediaFromAttachment = (attachment: Gql.BriefAttachment): string => {
    const mediaType = transformGqlMediaTypeToLightboxSourceType(attachment?.type);

    switch (mediaType) {
        case 'pdf':
            return attachment.pdfOpenUrl || '';
        case 'audio':
        case 'video':
            return attachment.mediaUrl || '';
        case 'image':
        default:
            return (
                attachment.previewUrls?.find(
                    (urlObject) => urlObject.transformation === Gql.AttachmentPreviewTransformation.None
                )?.url || ''
            );
    }
};

export const extractThumbnailFromAttachment = (attachment: Gql.BriefAttachment): string =>
    attachment.previewUrls?.find(
        (urlObject) => urlObject.transformation === Gql.AttachmentPreviewTransformation.BriefMediumPreview
    )?.url || '';
